import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a39478b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "im-top",
  style: {"-webkit-app-region":"drag"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-24gl-minimization" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-guanbi1" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { getCurrentInstance, ref } from "vue";
const iconBig = "icon-v-yk_fangkuai";
const iconSmall = "icon-v-xiaoxitixingchuangkoudanchufangshi";

export default /*#__PURE__*/_defineComponent({
  __name: 'Top',
  setup(__props) {

const { proxy } = getCurrentInstance();
function min() {
  proxy.$winControl.default.min();
}
const icon = ref(iconSmall);

function max() {
  proxy.$winControl.default.max();
  icon.value =
    icon.value === iconBig
      ? "icon-v-xiaoxitixingchuangkoudanchufangshi"
      : iconBig;
}

function close() {
  proxy.$winControl.default.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (min())),
      style: {"-webkit-app-region":"no-drag"}
    }, _hoisted_3),
    _createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (max())),
      style: {"-webkit-app-region":"no-drag"}
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["iconfont", icon.value])
      }, null, 2)
    ]),
    _createElementVNode("a", {
      href: "javascript:void(0)",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (close())),
      style: {"-webkit-app-region":"no-drag"}
    }, _hoisted_5)
  ]))
}
}

})